import { useEffect } from "react";

import { Location } from "custom-types/Location";
import { UserAddress } from "custom-types/UserAddress";

/*
 * Please do not use these.
 * They are deprecated functions - we should migrate away from them.
 */
const dispatchLocationChanged = (loc: UserAddress | Location) => {
  const userLocationUpdatedEvent = new CustomEvent("userLocationUpdated", {
    detail: loc,
  });
  window.dispatchEvent(userLocationUpdatedEvent);
};

export const useDeprecatedLocationFunctions = () => {
  useEffect(() => {
    if (!window.locationUtils) {
      window.locationUtils = {
        dispatchLocationChanged,
      };
    }
  }, []);
};
